import { collectionPageSlice } from './collection-page';
export const collectionPageActions = collectionPageSlice.actions;

export const { reducer: collectionPageReducer } = collectionPageSlice;
export * from './types';
